<template>
  <footer class="ux-footer">
    <div class="ux-footer-inner">
      <div class="ux-footer-grid">
        <div class="ux-footer-brand">
          <router-link to="/" :aria-label="`${appName} home`">
            <img v-if="logoLoaded" src="/web-logo-dark.svg" :alt="appName" @error="logoLoaded = false" />
            <span v-else>{{ appName }}</span>
          </router-link>
          <p>A little progress. Every day.<br />Make room for your next skill.</p>
        </div>
        <nav aria-label="Explore">
          <h2>Explore</h2>
          <router-link to="/courses">Courses</router-link>
          <router-link to="/about">About us</router-link>
          <router-link to="/verify-certificate">Verify a certificate</router-link>
        </nav>
        <nav aria-label="Information and preferences">
          <h2>Good to know</h2>
          <router-link to="/legal">Legal &amp; privacy</router-link>
          <button @click="resetConsent">Cookie preferences</button>
        </nav>
      </div>
      <p class="ux-footer-copyright">© {{ year }} {{ appName }}. All rights reserved.</p>
    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'
import { appName } from '@/utils/appInfo'
import { resetConsent } from '@/utils/cookies'
const year = new Date().getFullYear()
const logoLoaded = ref(true)
</script>
